// This module uses `require` and late imports to support isomorphic rendering.
import { toast } from 'react-toastify';

import getMessage from './getMessage';

const baseOptions = {
  autoClose: false,
  position: 'bottom-right',
}

const successOptions = {
  ...baseOptions,
};

const errorOptions = {
  ...baseOptions,
};

const infoOptions = {
  ...baseOptions,
};

export function notifyError(message) {
  if (typeof window !== 'undefined') {
    toast.dismiss();

    if (message) {
      toast.error(message, errorOptions); // add type: 'error' to options
    } else {
      toast.error('Jokin meni pieleen.', errorOptions); // add type: 'error' to options
    }
  }
}

export function notifySuccess(message) {
  if (typeof window !== 'undefined') {
    toast.dismiss();

    if (message) {
      toast.success(message, successOptions); // add type: 'success' to options
    } else {
      toast.success('Toiminto onnistui.', successOptions); // add type: 'success' to options
    }
  }
}

export function localizedNotifyError(string, ...details) {
  toast.dismiss();

  let detailsString = ''
  if (details) {
    for (let detail of details) {
      detailsString += '. ' + getMessage(detail);
    }
  }
  toast.error()

  if (string) {
    toast.error(getMessage(string) + detailsString, errorOptions); // add type: 'error' to options
  } else {
    toast.error('Jokin meni pieleen.', errorOptions); // add type: 'error' to options
  }
}

export function notifyInfo(content) {
  toast.dismiss()
  if (content) {
    toast.info(content, infoOptions)
  }
}

export function localizedNotifySuccess(string) {
  toast.dismiss();

  if (string) {
    toast.success(getMessage(string), successOptions); // add type: 'success' to options
  } else {
    toast.success('Toiminto onnistui.', successOptions); // add type: 'success' to options
  }
}


